/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OWLogCategory = {
    TIME: 'TIME',
    EVENT: 'EVENT'
} as const;
export type OWLogCategory = typeof OWLogCategory[keyof typeof OWLogCategory];


export function instanceOfOWLogCategory(value: any): boolean {
    for (const key in OWLogCategory) {
        if (Object.prototype.hasOwnProperty.call(OWLogCategory, key)) {
            if (OWLogCategory[key as keyof typeof OWLogCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OWLogCategoryFromJSON(json: any): OWLogCategory {
    return OWLogCategoryFromJSONTyped(json, false);
}

export function OWLogCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWLogCategory {
    return json as OWLogCategory;
}

export function OWLogCategoryToJSON(value?: OWLogCategory | null): any {
    return value as any;
}

export function OWLogCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): OWLogCategory {
    return value as OWLogCategory;
}

